export const callIfChanged = fn => (_, newValue, oldValue) => {
  if (newValue !== oldValue) {
    fn(_, newValue, oldValue);
  }
};
